<div class="filter-container">
    <mat-form-field class="filter-input" appearance="outline">
        <mat-label>Search...</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input #filterF matInput>
        @if (filterF.value) {
            <button mat-icon-button matSuffix (click)="clearFilter()">
                <mat-icon>clear</mat-icon>
            </button>
        }
    </mat-form-field>

    <mat-form-field appearance="outline">
        <mat-label>Created from</mat-label>
        <input matInput [matDatepicker]="pickerFrom" [(ngModel)]="dateFrom" (dateChange)="storeFilters()">
        <mat-datepicker-toggle matIconSuffix [for]="pickerFrom">
            <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
        </mat-datepicker-toggle>
        <mat-datepicker #pickerFrom></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="filter-date" appearance="outline">
        <mat-label>Created to</mat-label>
        <input matInput [matDatepicker]="pickerTo" [(ngModel)]="dateTo" (dateChange)="storeFilters()">
        <mat-datepicker-toggle matIconSuffix [for]="pickerTo">
            <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
        </mat-datepicker-toggle>
        <mat-datepicker #pickerTo></mat-datepicker>
    </mat-form-field>

    @if (dateFrom || dateTo) {
        <button mat-icon-button (click)="clearDateRange()">
            <mat-icon>clear</mat-icon>
        </button>
    }

    <mat-slide-toggle
            class="slide-toggle"
            (change)="changeShowExports()"
            [checked]="_showExport">
        Show export
    </mat-slide-toggle>

    <div class="status-filter-container">
        <div class="status-filter-header">Status</div>
        <div class="iconfilter">
            <mat-icon (click)="setIconFilter('new')" [ngClass]="{'icon-on': _iconFilter === 'new'}" class="icons"
                      matTooltip="new">whatshot
            </mat-icon>
            <mat-icon (click)="setIconFilter('assigned')" [ngClass]="{'icon-on': _iconFilter === 'assigned'}"
                      class="icons"
                      matTooltip="assigned">person
            </mat-icon>
            <mat-icon (click)="setIconFilter('closed')" [ngClass]="{'icon-on': _iconFilter === 'closed'}"
                      class="icons"
                      matTooltip="underway">loop
            </mat-icon>
            <mat-icon (click)="setIconFilter('archived')" [ngClass]="{'icon-on': _iconFilter === 'archived'}"
                      class="icons" matTooltip="archived">archive
            </mat-icon>
        </div>
    </div>
</div>